import {
  OldTrackingConditions,
  OldTrackingConditionsTypes,
  TrackingConditions,
  TrackingConditionsTypes
} from 'consts/giConsts'
import useGaFlags from './useGaFlags'

export default () => {
  const { AIForHI } = useGaFlags()

  const getTrackingConditionsTypes = () => (AIForHI ? TrackingConditionsTypes : OldTrackingConditionsTypes)
  const getTrackingConditions = () => (AIForHI ? TrackingConditions : OldTrackingConditions)

  return {
    getTrackingConditionsTypes,
    getTrackingConditions
  }
}
